<div class="document-upload">
  <p>{{ props.label }}</p>

  @if (isDisabled()) {
    <!-- Ha van dokumentum és nem szerkesztési módban -->
    @if (hasDocument()) {
      <div class="existing-document">
        <div class="document-info">
          <i
            class="pi"
            [ngClass]="{
              'pi-file-pdf': getDocument().fileType?.includes('pdf'),
              'pi-file-image': getDocument().fileType?.includes('image'),
              'pi-file':
                !getDocument().fileType?.includes('pdf') &&
                !getDocument().fileType?.includes('image'),
            }"></i>
          <div class="document-details">
            <div class="filename">{{ getDocument().fileName }}</div>
            <div class="filesize">
              {{ formatFileSize(getDocument().fileSize) }}
            </div>
            <div class="upload-date">
              Feltöltve: {{ getDocument().uploadDate | date: 'yyyy.MM.dd' }}
            </div>
          </div>
        </div>
        <div class="document-actions">
          <button
            pButton
            icon="pi pi-download"
            class="p-button-text p-button-rounded"
            pTooltip="Letöltés"
            type="button"
            [disabled]="isDownloadDisabled()"
            (click)="downloadDocument()"></button>
        </div>
      </div>
    }

    @if (!hasDocument()) {
      <div class="no-document-message">
        <i class="pi pi-file text-gray-400 mr-2"></i>
        <span class="text-muted">{{ props.placeholderText || 'Nincs feltöltve dokumentum' }}</span>
      </div>
    }
  }

  @if (!isDisabled()) {
    <!-- Ha van dokumentum DE szerkesztési módban -->
     @if (hasDocument() && !files.length && !replacing) {
      <div class="existing-document">
        <div class="document-info">
          <i
            class="pi"
            [ngClass]="{
              'pi-file-pdf': getDocument().fileType?.includes('pdf'),
              'pi-file-image': getDocument().fileType?.includes('image'),
              'pi-file':
                !getDocument().fileType?.includes('pdf') &&
                !getDocument().fileType?.includes('image'),
            }"></i>
          <div class="document-details">
            <div class="filename">{{ getDocument().fileName }}</div>
            <div class="filesize">
              {{ formatFileSize(getDocument().fileSize) }}
            </div>
            <div class="upload-date">
              Feltöltve: {{ getDocument().uploadDate | date: 'yyyy.MM.dd' }}
            </div>
          </div>
        </div>
        <div class="document-actions">
          <button
            pButton
            icon="pi pi-download"
            class="p-button-text p-button-rounded"
            pTooltip="Letöltés"
            type="button"
            [disabled]="isDownloadDisabled()"
            (click)="downloadDocument()"></button>
          <button
            pButton
            icon="pi pi-sync"
            class="p-button-text p-button-rounded"
            pTooltip="Csere"
            type="button"
            (click)="startReplace()"></button>
          <button
            pButton
            [icon]="deleting ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"
            class="p-button-text p-button-rounded p-button-danger"
            pTooltip="Törlés"
            type="button"
            [disabled]="deleting"
            (click)="onRemove()"></button>
        </div>
      </div>
    }

    <!-- Feltöltő rész szerkesztési módban, csere közben, VAGY ha nincs dokumentum és szerkeszthető -->
    @if (!hasDocument() || files.length > 0 || replacing) {
      <ngx-dropzone
        [accept]="
          props.accept || 'application/pdf,image/jpeg,image/png,image/jpg'
        "
        (change)="onSelect($event)">
        <ngx-dropzone-label>
          Húzd be a fájlt, vagy kattints ide a tallózáshoz
          <div class="file-types">A fájl típusa PDF, JPG, JPEG, PNG lehet.</div>
        </ngx-dropzone-label>

        @for (f of files; track $index) {
          <ngx-dropzone-preview [removable]="true" (removed)="onRemove()">
            <ngx-dropzone-label
              >{{ f.name }} ({{ formatFileSize(f.size) }})</ngx-dropzone-label
            >
          </ngx-dropzone-preview>
        }
      </ngx-dropzone>

      @if (replacing && !files.length) {
        <button
          pButton
          label="Mégse"
          icon="pi pi-times"
          class="p-button-text mt-2"
          type="button"
          (click)="cancelReplace()"></button>
      }
    }
  }
</div>
